import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Settings as SettingsIcon } from 'lucide-react';
import DeviceTester from './DeviceTester';

/**
 * DeviceTesterModal — quick popup version of the device tester, shown from Studio/Battle.
 */
export default function DeviceTesterModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass border-white/10 max-w-md md:max-w-lg text-white max-h-[92vh] overflow-y-auto" data-testid="device-tester-modal">
        <DialogHeader>
          <div className="w-12 h-12 mx-auto rounded-2xl bg-gradient-to-br from-pink-500 via-purple-600 to-blue-500 flex items-center justify-center mb-1">
            <SettingsIcon size={20} className="text-white" />
          </div>
          <DialogTitle className="text-xl font-black text-center">Test caméra & micro</DialogTitle>
          <DialogDescription className="text-zinc-400 text-center text-sm">
            Vérifie que tout fonctionne avant la battle.
          </DialogDescription>
        </DialogHeader>
        <DeviceTester compact />
      </DialogContent>
    </Dialog>
  );
}
